// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 7/12/2024
 */


 .RequestImages_container__wRXZO {
    border: solid 1px #c4c4c4;
    margin-top: 5px;
    border-radius: 0.5rem;
    background-color: #fff;
}

.RequestImages_imgList__F4Q8T {
    /* width: 580; */
    max-height: 250px;
    overflow-x: clip;
    overflow-y: auto;
    padding: 0 1rem;
}

.RequestImages_itemContainer__ZM9Ub {
    width: 10;
    height: 10;
}

.RequestImages_image__tozf6 {
    border-style: solid;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-color: black;
    border-width: 1px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/Shared/RequestImages.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;;CAGD;IACG,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":["/*\r\n * Copyright (c) 2024 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 7/12/2024\r\n */\r\n\r\n\r\n .container {\r\n    border: solid 1px #c4c4c4;\r\n    margin-top: 5px;\r\n    border-radius: 0.5rem;\r\n    background-color: #fff;\r\n}\r\n\r\n.imgList {\r\n    /* width: 580; */\r\n    max-height: 250px;\r\n    overflow-x: clip;\r\n    overflow-y: auto;\r\n    padding: 0 1rem;\r\n}\r\n\r\n.itemContainer {\r\n    width: 10;\r\n    height: 10;\r\n}\r\n\r\n.image {\r\n    border-style: solid;\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    object-fit: contain;\r\n    border-color: black;\r\n    border-width: 1px;\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RequestImages_container__wRXZO`,
	"imgList": `RequestImages_imgList__F4Q8T`,
	"itemContainer": `RequestImages_itemContainer__ZM9Ub`,
	"image": `RequestImages_image__tozf6`
};
export default ___CSS_LOADER_EXPORT___;
